import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight, Phone } from 'lucide-react';
import screenImg from '../assets/city-hardware-window.png';
import windowsImg from '../assets/city-hardware-windows.png';
import './PageStyles.css';
import './WindowRepairPage.css';

const SERVICES = [
  'Cracked or broken glass replacement',
  'Single and double-pane window repair',
  'Drafty or leaking frame repair',
  'Window seal & weatherstripping',
  'Window screen repair & replacement',
  'Hardware, locks, and latch repair',
  'Sliding & casement window repair',
  'Storm window service',
];

function WindowRepairPage() {
  return (
    <div className="page">
      {/* Page Hero — dark with photo */}
      <div className="wr-hero">
        <img
          src={windowsImg}
          alt="Freshly repaired window frames ready for installation"
          className="wr-hero__bg"
        />
        <div className="wr-hero__overlay" />
        <div className="container wr-hero__content">
          <div className="page-hero__eyebrow">City Hardware — Detroit</div>
          <h1 className="page-hero__heading">Window Repair<br/>Services</h1>
          <p className="page-hero__sub">
            Fast fixes for broken or aging windows. Trusted window repairs done right —
            city hardware style.
          </p>
          <div className="page-hero__actions">
            <a href="tel:+13135828860" className="btn btn--red">
              <Phone size={16} />
              Call for a Quote
            </a>
            <Link to="/contact" className="btn btn--outline-white">
              Send a Message
            </Link>
          </div>
        </div>
      </div>

      {/* Services list */}
      <section className="page-section">
        <div className="container page-two-col">
          <div>
            <div className="section-eyebrow">What We Repair</div>
            <h2 className="section-heading">Repair, Replace, Restore.</h2>
            <p className="section-body">
              Cracked pane? Drafty frame? Don't replace what can be repaired.
              City Hardware makes window repair simple, affordable, and reliable.
              Our experienced team handles everything from single-pane glass to
              full-frame restoration for Detroit homes and businesses.
            </p>
            <Link to="/contact" className="btn btn--red" style={{ marginTop: '2rem', display: 'inline-flex' }}>
              Get a Window Repair Quote <ArrowRight size={16} />
            </Link>
          </div>

          <div className="service-list">
            {SERVICES.map(s => (
              <div key={s} className="service-list__item">
                <CheckCircle size={18} className="service-list__icon" />
                <span>{s}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Screen repair photo feature */}
      <section className="wr-photo-band">
        <div className="container wr-photo-band__inner">
          <div className="wr-photo-band__image-wrap">
            <img
              src={screenImg}
              alt="Window screen being repaired at City Hardware Detroit"
              className="wr-photo-band__image"
            />
          </div>
          <div className="wr-photo-band__text">
            <div className="section-eyebrow">Screen Repair Too</div>
            <h2 className="section-heading">Torn Screen?<br/>We Fix That.</h2>
            <p className="section-body">
              Bring in your window or door screen and we'll re-screen it while you wait.
              Custom sizing available. Fast, affordable, and done right the first time.
            </p>
            <a href="tel:+13135828860" className="btn btn--red" style={{ marginTop: '1.5rem', display: 'inline-flex' }}>
              <Phone size={16} /> Ask About Screen Repair
            </a>
          </div>
        </div>
      </section>

      {/* Why repair instead of replace */}
      <section className="page-section page-section--gray">
        <div className="container">
          <div className="section-eyebrow">Why Repair?</div>
          <h2 className="section-heading">A Smarter Alternative<br/>to Replacement.</h2>
          <div className="three-col-grid">
            {[
              { title: 'Save Money', body: "Window replacement runs $400–$1,200 per window. Most repairs cost a fraction of that. Don't overspend when a fix will do." },
              { title: 'Faster Turnaround', body: 'Many repairs are completed the same day. No waiting weeks for a contractor — come in or call us.' },
              { title: 'Local Expertise', body: "Detroit homes have unique needs. Our team has been handling local window repairs for 35+ years. We know what works." },
            ].map(c => (
              <div key={c.title} className="info-card">
                <h3 className="info-card__title">{c.title}</h3>
                <p className="info-card__body">{c.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Footer band */}
      <section className="page-cta-band">
        <div className="container page-cta-band__inner">
          <div>
            <h2 className="page-cta-band__heading">Ready to Fix Your Windows?</h2>
            <p className="page-cta-band__sub">Stop in, call us, or send a message. We'll have you sorted fast.</p>
          </div>
          <div className="page-cta-band__actions">
            <a href="tel:+13135828860" className="btn btn--red"><Phone size={16} /> (313) 582-8860</a>
            <Link to="/contact" className="btn btn--outline-black">Send a Message</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default WindowRepairPage;
